import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import "@/App.css";
import HomePage from "@/pages/HomePage";
import CasePage from "@/pages/CasePage";
import ServicePage from "@/pages/ServicePage";
import KiLoesungenPage from "@/pages/KiLoesungenPage";
import LocationPage from "@/pages/LocationPage";
import ImpressumPage from "@/pages/ImpressumPage";
import DatenschutzPage from "@/pages/DatenschutzPage";
import AdminPage from "@/pages/AdminPage";
import ScrollToTop from "@/components/ScrollToTop";
import CookieBanner from "@/components/CookieBanner";
import BackgroundFX from "@/components/BackgroundFX";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BackgroundFX />
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/case/:slug" element={<CasePage />} />
            <Route path="/service/:slug" element={<ServicePage />} />
            <Route path="/ki-loesungen" element={<KiLoesungenPage />} />
            <Route path="/drehort/:slug" element={<LocationPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
